import axios from 'axios'
 
const instance = axios.create({
  baseURL: 'https://www.huijianzhilian.com/realty-api/',
  // baseURL:'http://localhost:8089/realty-api/',
  timeout: 10000
});

export default instance;
